<template>
  <div>
    <div style="width: 100%">
      <img style="width: 100%" src="./img/顶部背景.png" alt="" />
    </div>

    <div class="bottomCss">
      <div class="xiangqing">
        <!-- 标题图片 -->
        <div class="imgCss">
          <div>{{ this.data.name }}</div>
          <div class="tupailie">
            <img class="datu" :src="this.datu" alt="" />
            <div class="xtpl">
              <div v-for="(item,index) in this.imgdata" :key="index">
                <img
                  @click="qiehuan(index)"
                  class="xioatu"
                  :src="item.url"
                  alt=""
                />
              </div>
              <!-- <img class="xioatu" :src="this.imgdata[2].url" alt="" />
              <img class="xioatu" :src="this.imgdata[3].url" alt="" /> -->
            </div>
          </div>
        </div>
        <!-- 产品简介 -->
        <div class="jianjie">
          <div
            style="
              margin-top: 42px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            产品介绍
          </div>
          <div style="display: flex; margin-top: 24px; margin-bottom: 24px">
            <div
              v-for="(item, index) in data.biaioqian"
              :key="index"
              class="biaoqian"
            >
              {{ item.bq }}
            </div>
          </div>
          <div
            style="
              font-size: 20px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 38px;
              margin-bottom: 36px;
            "
          >
            {{ this.data.jieshao }}
          </div>
        </div>
        <!-- 产品优点 -->
        <div class="youdian">
          <div
            style="
              margin-top: 36px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            产品优点
          </div>
          <div class="ydlb">
            <div class="ydnr" v-for="(item,index) in this.youdianData" :key="index">{{item.yd}}</div>
          </div>
        </div>
        <!-- 关键参数 -->
        <div class="canshu">
          <div
            style="
              margin-top: 36px;
              font-size: 30px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #000000;
            "
          >
            关键参数
          </div>
          <div class="csimg">
            <img style="width: 100%;" :src=this.canshuData alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      youdianData:[
        {yd:"正弦波电流"},
        {yd:"多接口设计，即插即用"},
        {yd:"智能用电防护系统，多重保障"},
        {yd:"经过UL38.3防震测试，防震抗摔"},
        {yd:"充电方式多样，可根据场景进行充电选择"},
      ],
      data: {
        name: "600W户外电源",
        biaioqian: [{ bq: "正弦波电流" }, { bq: "多接口设计" }, { bq: "防震抗摔" }, { bq: "充电方式多样化" }, { bq: "智能用电防护系统" }],
        jieshao:
          "户外600W便捷电源拥有448Wh的容量，是自驾旅行、家庭应急的必备电源，600W高功率正弦波AC输出，循环寿命可达3000次。内置车充口12V输出，方便快捷。",
        url: require("@/views/product/img/600w户外.png"),
      },
      datu:require("@/views/product/img/600w户外.png"),
      canshuData:require("./img/600w户外电源.png"),
      imgdata: [
        { url: require("@/views/product/img/600w户外.png") },
        { url: require("@/views/product/img/600w户外.png") },
        { url: require("@/views/product/img/600w户外.png") },
      ],

    };
  },
  methods: {
    qiehuan(index) {
      if (index==0) {
        this.datu=this.imgdata[0].url
      }else if (index==1) {
        this.datu=this.imgdata[1].url
      }else if (index==2) {
        this.datu=this.imgdata[2].url
      }
    },
  },
  mounted() {
    console.log(this.$route.query.key, "xxxxxxxxxxx");
    // this.data = this.$route.query.key;
    // this.datu=this.$route.query.key.url
  },
};
</script>

<style scoped>
.bottomCss {
  width: 100%;
  height: 100%;
  background: #f2f5f8;
  display: flex;
  justify-content: center;
}
.xiangqing {
  width: 69%;
  background: #ffffff;
  margin-top: 4%;
  margin-bottom: 4%;
}
.imgCss {
  font-size: 38px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 54px;
}
.datu {
  width: 500px;
  height: 500px;
  margin-bottom: 16px;
  margin-top: 42px;
}
.tupailie {
  display: flex;
  flex-direction: column;
}
.xtpl {
  display: flex;
  justify-content: space-evenly;
}
.xioatu {
  width: 110px;
  height: 110px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
}
.xioatu:hover {
  width: 110px;
  height: 110px;
  border: 2px solid rgba(9, 64, 253, 1);
  border-radius: 12px 12px 12px 12px;
}
.jianjie {
  margin: 0px 64px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.youdian {
  margin: 0px 64px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.canshu {
  margin: 0px 64px 64px 64px;
}
.biaoqian {
  margin-right: 12px;
  height: 36px;
  background: rgba(9, 64, 253, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  border-radius: 6px 6px 6px 6px;
  color: #0940fd;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
.ydlb {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 36px;
}
.ydnr {
  width: 50%;
  font-size: 20px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  margin-top: 24px;
}
.ydnr::before {
  content: "";
  display: flex;
  width: 9px;
  height: 9px;
  background: #0940fd;
  border-radius: 50%;
  margin-right: 16px;
}
.csimg {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>